// Import model
import { FilterFcb2BProductTypeOptionRequest } from '../models/FilterFcb2BProductTypeOptionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { Fcb2BProductTypeOptionCondition } from '../models/Fcb2BProductTypeOptionCondition';
import { Fcb2BProductTypeOptionFields } from '../models/Fcb2BProductTypeOptionFields';
import { Fcb2BProductTypeOptionIndexedFields } from '../models/Fcb2BProductTypeOptionIndexedFields';

// Import dependency serializers (for complex types)
import { Fcb2BProductTypeOptionConditionSerializer } from './Fcb2BProductTypeOptionConditionSerializer';
import { Fcb2BProductTypeOptionFieldsSerializer } from './Fcb2BProductTypeOptionFieldsSerializer';
import { Fcb2BProductTypeOptionIndexedFieldsSerializer } from './Fcb2BProductTypeOptionIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterFcb2BProductTypeOptionRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterFcb2BProductTypeOptionRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterFcb2BProductTypeOptionRequest instance
   */
  static deserialize(json: string): FilterFcb2BProductTypeOptionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterFcb2BProductTypeOptionRequest instance
   */
  static fromObject(obj: any): FilterFcb2BProductTypeOptionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterFcb2BProductTypeOptionRequest');
    }


    const instance: FilterFcb2BProductTypeOptionRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as Fcb2BProductTypeOptionIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as Fcb2BProductTypeOptionFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        Fcb2BProductTypeOptionConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterFcb2BProductTypeOptionRequest instances
   */
  static deserializeArray(json: string): FilterFcb2BProductTypeOptionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterFcb2BProductTypeOptionRequest instance to a JSON string
   */
  static serialize(instance: FilterFcb2BProductTypeOptionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterFcb2BProductTypeOptionRequest instance to a plain object
   */
  static toObject(instance: FilterFcb2BProductTypeOptionRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        Fcb2BProductTypeOptionConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterFcb2BProductTypeOptionRequest instances to a JSON string
   */
  static serializeArray(instances: FilterFcb2BProductTypeOptionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
